import React from 'react';
import { Typography, Tabs } from 'antd';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import UserDetailForm from '../../components/user/userDetailForm';
import CompanyDetail from './companyDetail';
import TeamDetails from './teamDetails';
import requireAuth from '../../hocs/requireAuth';
import {
  refreshUserDetails,
  userMangement,
} from '../../redux/actions/authActions';
import { CHANGE_SELECTED_COMPANY } from '../../constants/actionTypes';
import { hasPermission } from '../../utilities/helpers';

const { Text } = Typography;

function UserScreen() {
  const selectedCompany = useSelector((state) =>
    get(state, 'auth.selectedCompany')
  );
  const dispatch = useDispatch();
  const { permissions } = useSelector((state) => get(state, 'auth.role'));

  const onRefreshSelectedCompany = () => {
    dispatch(
      userMangement('get.company', { company_id: get(selectedCompany, 'id') })
    ).then((result) => {
      dispatch({
        type: CHANGE_SELECTED_COMPANY,
        payload: get(result, 'data'),
      });
    });
  };

  const refreshUser = (refreshCompany = false) => {
    dispatch(refreshUserDetails()).then(() => {
      if (refreshCompany) {
        onRefreshSelectedCompany();
      }
    });
  };

  const hasViewUserPermission = hasPermission(permissions, ['PERM_VIEW_USER']);

  return (
    <div>
      <div className="user-header">
        <div>
          <Text className="main-heading">User</Text>
        </div>
      </div>
      <div className="user-tab-container">
        <Tabs defaultActiveKey="1" animated={{ inkBar: true, tabPane: true }}>
          <Tabs.TabPane tab="User Details" key="1">
            <UserDetailForm refreshUser={refreshUser} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Company Details" key="2">
            <CompanyDetail refreshUser={refreshUser} />
          </Tabs.TabPane>
          {hasViewUserPermission && (
            <Tabs.TabPane tab="Team" key="3">
              <TeamDetails />
            </Tabs.TabPane>
          )}
        </Tabs>
      </div>
    </div>
  );
}

export default requireAuth(UserScreen);
